import React, { useEffect, useRef, useState } from 'react';

import MentorMatchV2 from '../question_components/mentor_match_v2';

const placeholderStyle = {
  border: '1px dashed #cbd5e1',
  borderRadius: '10px',
  padding: '32px 24px',
  textAlign: 'center',
  color: '#475569',
  fontSize: '14px',
  lineHeight: 1.5,
};

/**
 * A mentor_match stage is not a traditional question — it has no data key
 * or logic rules. Reaching it runs the live mentor search, reusing the same
 * search / matched card experience as the hardcoded questionnaire flows
 * (e.g. XCOPRI): it searches on mount, then hands off straight to the
 * matched mentor's conversation once the member continues. Optional heading
 * and body on the question replace the no-mentor message when the search
 * finds no match. Without onRequestMatch (the admin builder preview) it
 * renders a static placeholder — matching requires a live account, active
 * mentors, and a logged-in member.
 */
const MentorMatchQuestion = ({ question, onRequestMatch, onOutcome, firstMessageAnswer }) => {
  const [patientPartner, setPatientPartner] = useState(null);
  const [mentorFound, setMentorFound] = useState(null);
  const requestedRef = useRef(false);
  const previewOnly = typeof onRequestMatch !== 'function';

  useEffect(() => {
    if (previewOnly || requestedRef.current) return undefined;
    requestedRef.current = true;

    return onRequestMatch({
      onSetPatientPartner: setPatientPartner,
      onMentorFound: (found) => {
        setMentorFound(found);
        onOutcome();
      },
      onNoMentorFound: () => {
        setMentorFound(false);
        onOutcome();
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question.id, previewOnly]);

  if (previewOnly) {
    return (
      <div style={placeholderStyle}>
        <strong>Mentor match</strong>
        <p style={{ margin: '8px 0 0' }}>
          Shown as a placeholder in preview — this stage runs the live mentor search and match card, which requires a
          live account, active mentors, and a logged-in member.
        </p>
      </div>
    );
  }

  return (
    <MentorMatchV2
      patientPartner={patientPartner}
      mentorFound={mentorFound}
      noMentorHeading={question.noMentorHeading}
      noMentorBody={question.noMentorBody}
      firstMessageAnswer={firstMessageAnswer}
    />
  );
};

export default MentorMatchQuestion;
